/**
 * Page is only accessible if user is authenticated.
 */

import UserApi from '@api/UserApi';

export default function({ to, from, store }) {
    let user = store.getters.user;
    let company = store.getters.company;
    let project = store.getters.project;
    let redirect = store.getters.redirect;

    // Handle redirect.
    if (to.name !== 'login' && !store.getters.apiKey) {
        // Not authenticated. Go to login page.
        return { name: 'login' };
    } else if (!user) {
        // No user. Get user and redirect.
        return UserApi.getUser()
            .then((response) => {
                return to;
            }, () => {
                return { name: 'login' };
            });
    } else if (to.name !== 'authy' && user.is_authy_expired === true) {
        // MFA is expired. Prompt for MFA.
        return { name: 'authy' };
    } else if (to.name !== 'account-setup' && !user.name && !company && !project) {
        // No name. Prompt for account setup.
        return { name: 'account-setup' };
    } else if (to.name !== 'company-setup' && user.name && !company && !project) {
        // No company. Prompt for company setup.
        return { name: 'company-setup' };
    } else if (to.name !== 'project-setup' && user.name && company && !project) {
        // No project. Prompt for project setup.
        return { name: 'project-setup' };
    } else if (redirect && to.name !== redirect && user.name && company && project) {
        store.commit('setRedirect', null);
        return { name: redirect };
    }
}
